import { CalendarClock } from "lucide-react";

// Trust meta strip shown at the top of guide pages.
const GuideMeta = ({ lastReviewed = "July 2026", readTime = "10 min read" }) => (
  <div className="mt-6 inline-flex items-center gap-3 text-xs text-[#475569] bg-white border border-[#DCE7E3] rounded-full px-4 py-1.5">
    <span className="inline-flex items-center gap-1.5">
      <CalendarClock className="w-3.5 h-3.5 text-[#0F766E]" /> Last reviewed: <strong className="text-[#0B1220] font-semibold">{lastReviewed}</strong>
    </span>
    <span className="w-px h-3 bg-[#DCE7E3]" />
    <span>{readTime}</span>
  </div>
);

export default GuideMeta;
